import { Box, styled } from '@planne-software/uni/mui/material';
import { CalendarCell, calendarCellClasses } from '@planne-software/uni/DatePicker';
import { CELL_HEIGHT, CELL_WIDTH } from '@src/domains/scheduling/components/constants';

export const CellRoot = styled(Box)({
  display: 'inline-flex',
  justifyContent: 'center',
  width: CELL_WIDTH,
  height: CELL_HEIGHT,
  flexShrink: 0,
});

export const StyledCalendarCell = styled(CalendarCell, {
  shouldForwardProp: (prop) => prop !== 'pending',
})<{ pending?: boolean }>(({ theme, pending }) => {
  if (pending) {
    return {
      width: CELL_WIDTH,
      height: CELL_HEIGHT,
      margin: 0,
      padding: 0,
      borderRadius: '4px',
      border: '0 !important',
      position: 'relative',
      color: 'transparent !important',
      pointerEvents: 'none',
      animation: 'planne-day-ripple 1.4s ease-in-out infinite',
      '@keyframes planne-day-ripple': {
        '0%': { backgroundColor: theme.tokens.colors['text-color-neutral-softer']! },
        '50%': { backgroundColor: 'transparent' },
        '100%': { backgroundColor: theme.tokens.colors['text-color-neutral-softer']! },
      },
      '& > *': { visibility: 'hidden' },
    };
  }

  return {
    width: CELL_WIDTH,
    height: CELL_HEIGHT,
    margin: 0,
    padding: 0,
    borderRadius: '4px',
    border: '0 !important',
    transition: 'background-color 0.15s',
    [`&.${calendarCellClasses.success}, &.${calendarCellClasses.neutral}`]: {
      border: '0 !important',
    },
    [`&.${calendarCellClasses.neutral}`]: {
      backgroundColor: `${theme.tokens.colors['fill-color-neutral-softest']!} !important`,
      color: `${theme.tokens.colors['text-color-neutral-strongest']!} !important`,
    },
    '& > span:first-of-type': {
      justifyContent: 'space-between',
      paddingTop: 1,
      paddingBottom: 1,
      gap: 0,
      '& > span:first-of-type': {
        ...theme.tokens.typography['text-sm-medium'],
      },
    },
  };
});

export const CellPriceText = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-mini-medium'],
  minHeight: 16,
}));
